import { API_URL } from '@api/apiDictionary';
import { RESTClient, RESTClientMock } from '@api/client';
import { USE_API_MOCKS } from '../env';
import { CommonInventoryType } from '@dynamika-shared/types/inventory';
import type {
  Invitation,
  CreateInvitationRequest,
} from '@restore/invitationsUserManagement/invitationsUserManagement.types';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export type InvitationRequestArgs = {
  sponsorId: string;
};

export const fetchInvitationsList = (args: InvitationRequestArgs) => {
  return api.get<Invitation[]>(API_URL.invitations, {
    params: {
      sponsorId: args.sponsorId,
    },
  });
};

export const createInvitation = (data: CreateInvitationRequest) => {
  return api.post(API_URL.invitations, data);
};

export const revokeInvitation = (id: string) => {
  return api.delete(API_URL.invitationById.replace(':id', id));
};

export const fetchInvitationSponsors = () => {
  return api.get<CommonInventoryType[]>(API_URL.invitationSponsors);
};
